import { EndSessionRequest } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import React, { useEffect, useRef } from 'react'
import useLoggedInCookie from '../hooks/useLoggedInCookie'

const Logout = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const { instance } = useMsal()
  const [, removeLoggedInCookie] = useLoggedInCookie()
  const mountedRef = useRef(false)
  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      if (instance.getActiveAccount() === null) {
        window.location.href = govCMSHome
        return
      }
      removeLoggedInCookie()
      const request: EndSessionRequest = {
        postLogoutRedirectUri: govCMSHome,
      }
      instance.logoutRedirect(request)
    }
    return () => {
      mountedRef.current = false
    }
  }, [])

  const LoadingComponent = () => {
    return (
      <div className="redirect-overlay">
        <div className="justify-content-center">
          <p>
            <b>Please wait while you are logged out</b>
          </p>
          <div className="pacterpillar">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <LoadingComponent />
    </>
  )
}

export default Logout
